import type { HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

export interface SectionTagProps extends HTMLAttributes<HTMLSpanElement> {
  label: string;
  /**
   * default   — обводка + текст `tag-foreground` (#4E535E), светлый фон
   * onTinted  — обводка + текст currentColor, для тёмного/красного фона
   * muted     — приглушённый secondary-тег (серая обводка + серый текст)
   */
  variant?: "default" | "onTinted" | "muted";
  uppercase?: boolean;
}

/** Тег секции (tag-lite): круг 6×6 только обводкой, gap 8px, Inter 16px / lh 1.2 — Figma ZNAKI. */
export function SectionTag({
  label,
  variant = "default",
  uppercase = false,
  className,
  ...rest
}: SectionTagProps) {
  const isTinted = variant === "onTinted";
  const isMuted = variant === "muted";
  return (
    <span
      className={cn(
        "inline-flex items-center gap-2 font-sans text-base font-normal leading-[1.2] tracking-normal",
        isTinted && "text-current opacity-90",
        isMuted && "text-muted-foreground",
        !isTinted && !isMuted && "text-tag-foreground",
        uppercase && "uppercase",
        className
      )}
      {...rest}
    >
      <span
        className={cn(
          "size-1.5 shrink-0 rounded-full border bg-transparent",
          isTinted && "border-current opacity-90",
          isMuted && "border-muted-foreground",
          !isTinted && !isMuted && "border-tag-foreground"
        )}
        aria-hidden
      />
      {label}
    </span>
  );
}
